var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Logo } from '@app/Components/Logo/Logo';
import styles from './HeaderLimited.module.scss';
var HeaderLimited = /** @class */ (function (_super) {
    __extends(HeaderLimited, _super);
    function HeaderLimited() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderLimited.prototype.render = function () {
        return (React.createElement("div", { className: styles.container },
            React.createElement("div", { className: styles.line },
                React.createElement(Logo, null))));
    };
    return HeaderLimited;
}(React.PureComponent));
export { HeaderLimited };
